/* eslint-disable  */
//@ts-nocheck

import {
  faBookmark,
  faEyeSlash,
  faList,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Program } from '@playbook-technologies/common-enums';
import React from 'react';
import { Link } from 'react-router';

type ProgramMenuProps = {
  programs: Array<any>;
  creatorId: number;
  selectedProgramId: number;
  showLibrary: boolean;
};
export class ProgramMenu extends React.Component<ProgramMenuProps> {
  getProgramStyle = (programId, program = undefined) => {
    if (this.props.selectedProgramId == programId) {
      if (programId === 0) {
        return {
          color: '#fff',
          background: '#7849ff',
          transition: 'background .2s ease-in-out',
        };
      } else if (programId == program.id) {
        return {
          color: '#fff',
          background: `#${program.color}`,
          transition: 'background .2s ease-in-out',
        };
      } else {
        return {
          color: '#171e33',
          background: '#d0d0d0',
          transition: 'background .2s ease-in-out',
        };
      }
    }
    return {
      color: '#171e33',
      background: '#fff',
      transition: 'background .2s ease-in-out',
    };
  };

  render() {
    const items = [];
    for (let p of this.props.programs) {
      items.push(
        <Link
          to={`/admin/partner/${this.props.creatorId}/workouts/published/${p.id}`}
          key={p.id}
          style={this.getProgramStyle(p.id, p)}
        >
          {/* <FontAwesomeIcon
            icon={p.type == 0 ? faList : faBookmark}
            className="mr-2"
          /> */}
          <span className="mr-2">{p.name}</span>
          {!p.isVisible && <FontAwesomeIcon icon={faEyeSlash} />}
          {p.accessType === Program.AccessType.Exclusive.value && ' 👑'}
          {p.isLocked && ' 🔒'}
        </Link>,
      );
    }

    return (
      <section className="programTabMenu">
        <div className="programTabSelector">
          {this.props.showLibrary ? (
            <Link
              to={`/admin/partner/${this.props.creatorId}/workouts/published/0`}
              key={0}
              style={this.getProgramStyle(0)}
            >
              Library
            </Link>
          ) : null}
          {items}
        </div>
      </section>
    );
  }
}

function ProgramTab({ program }) {
  const programName = program.isVisible ? program.name : `${program.name}*`;

  return (
    <div className="w-[100px]">
      {program.mediaCover ? (
        <img
          className="w-[100px] h-[100px] max-w-[100px] max-h-[100px] rounded-full object-cover"
          src={programImage(program)}
        />
      ) : (
        <div className="flex items-center justify-center w-[100px] h-[100px] max-w-[100px] max-h-[100px] bg-white rounded-full">
          {programName}
        </div>
      )}

      <div className="mt-2 text-center">
        {program.accessType === Program.AccessType.Exclusive.value && ' 👑'}
        {program.isLocked && ' 🔒'}
      </div>
    </div>
  );
}

function programImage(p) {
  if (!p.mediaCover) return null;

  const { cdn01, image } = p.mediaCover;

  return cdn01 + image;
}
